/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archival_RosterInputs */



/**
* | output |
* | --- |
* | "Known players" |
*
* @param {Archival_RosterInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const archival_roster = /** @type {((inputs?: Archival_RosterInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archival_RosterInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Joueurs connus")
	if (locale === "es") return /** @type {LocalizedString} */ ("Jugadores conocidos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Jogadores conhecidos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Giocatori noti")
	return /** @type {LocalizedString} */ ("Known players")
});